import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useOrpc } from '@/hooks/useClient'

export function useAdoptFacility() {
  const orpc = useOrpc()
  const queryClient = useQueryClient()
  return useMutation(
    orpc.facilityDiscoveryAdopt.mutationOptions({
      // Adopt may have saved a fax on the Organization; refetch the visible
      // search so the card shows the "Saved" source chip without a manual re-search.
      onSuccess: () => {
        void queryClient.invalidateQueries({ queryKey: orpc.facilityDiscoverySearch.key() })
      },
    }),
  )
}
